import { AlertTriangle, AlertOctagon } from 'lucide-react';
import { clsx } from 'clsx';

interface AlertCardProps {
  title: string;
  message: string;
  severity: 'warning' | 'critical';
}

export function AlertCard({ title, message, severity }: AlertCardProps) {
  return (
    <div
      className={clsx(
        'rounded-lg p-3 flex items-start gap-3 border',
        severity === 'critical' && 'bg-red-50 dark:bg-red-900/20 border-red-200 dark:border-red-800/50',
        severity === 'warning' && 'bg-amber-50 dark:bg-amber-900/20 border-amber-200 dark:border-amber-800/50'
      )}
    >
      {severity === 'critical' ? (
        <AlertOctagon className="h-5 w-5 text-red-500 dark:text-red-400 shrink-0 mt-0.5" />
      ) : (
        <AlertTriangle className="h-5 w-5 text-amber-500 dark:text-amber-400 shrink-0 mt-0.5" />
      )}
      <div>
        <p
          className={clsx(
            'text-sm font-medium',
            severity === 'critical' ? 'text-red-700 dark:text-red-300' : 'text-amber-700 dark:text-amber-300'
          )}
        >
          {title}
        </p>
        <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">{message}</p>
      </div>
    </div>
  );
}
